// Generated by Cursor
// Suppress ResizeObserver loop limit exceeded error
const resizeObserverErrorHandler = () => {
  const debounce = (func: Function, wait: number) => {
    let timeout: NodeJS.Timeout;
    return function executedFunction(...args: any[]) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  const _ResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super(debounce(callback, 16));
    }
  };
};

export default resizeObserverErrorHandler;
